import styled from 'styled-components'

import { Box as CustomBox } from '../../../../components/shared/styled'

export const Box = styled(CustomBox)`
    margin-top: 40px;
    padding: 30px 50px 50px 50px;
`
